export default __webpack_public_path__ + "static/media/pause.d63d2fd6.svg";